import { Users } from "lucide-react";
import { usePublicData } from "../../hooks/usePublicData";

export default function PublicPlayers() {
  const { data, loading } = usePublicData();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!data) return null;

  const { player_stats } = data;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold uppercase tracking-tight">
          Players
        </h1>
        <p className="text-muted-foreground mt-1">
          {player_stats.length} registered players
        </p>
      </div>

      <div className="bg-card border border-border rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-secondary/50 text-xs uppercase tracking-wider text-muted-foreground">
                <th className="p-3 text-left">Player</th>
                <th className="p-3 text-left">Team</th>
                <th className="p-3 text-center">#</th>
                <th className="p-3 text-center">Pos</th>
                <th className="p-3 text-center">G</th>
                <th className="p-3 text-center">A</th>
                <th className="p-3 text-center">YC</th>
                <th className="p-3 text-center">RC</th>
              </tr>
            </thead>
            <tbody>
              {player_stats
                .sort((a, b) => b.goals + b.assists - (a.goals + a.assists))
                .map((p) => (
                  <tr key={p.player_id} className="border-t border-border hover:bg-secondary/20">
                    <td className="p-3 font-medium">{p.player_name}</td>
                    <td className="p-3 text-muted-foreground">{p.team_name}</td>
                    <td className="p-3 text-center">{p.number || "-"}</td>
                    <td className="p-3 text-center text-xs">{p.position || "-"}</td>
                    <td className="p-3 text-center font-bold text-primary">{p.goals}</td>
                    <td className="p-3 text-center font-bold text-accent">{p.assists}</td>
                    <td className="p-3 text-center">
                      {p.yellow_cards > 0 && (
                        <span className="inline-flex items-center gap-1">
                          <span className="w-3 h-4 bg-amber-500 rounded-sm" />
                          {p.yellow_cards}
                        </span>
                      )}
                    </td>
                    <td className="p-3 text-center">
                      {p.red_cards > 0 && (
                        <span className="inline-flex items-center gap-1">
                          <span className="w-3 h-4 bg-red-500 rounded-sm" />
                          {p.red_cards}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
